import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminFaqService } from '@/modules/faq/services/admin-faq.service'
import { FaqCollectionModel } from '@/modules/faq/models/faq-collection.model'
import { FaqRequestModel } from '@/modules/faq/models/faq-request.model'

@vservice()
export class FaqUpdateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminFaqService
  ) {
  }

  isSuccess = false
  isLoading = false

  execute(id: number, data: FaqCollectionModel) {
    return this.service.update(id, this.request(data))
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  request(data): FaqRequestModel {
    return {
      answer: data.answer,
      question: data.question,
      type: data.type
    }
  }

}